import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Focusable, Switch, Tooltip } from '@cfa/react-core';

import { Stars } from '@/icons';

interface AutoAssignToggleProps {
  isSelected: boolean;
  onChange: (value: boolean) => void;
  isCompliance?: boolean;
}

const AutoAssignToggle: React.FC<AutoAssignToggleProps> = ({
  isSelected,
  onChange,
  isCompliance,
}) => {
  const { t } = useTranslation();

  return (
    <div className="border-brand-navy dark:border-tag-navy-base dark:bg-tag-navy-container mt-6 mb-4 flex items-center justify-between gap-2 rounded border bg-[#e6f0f5ff] p-3">
      <div className="flex min-w-0 items-center gap-2">
        <Stars className="text-brand-navy dark:text-contrast" />
        <p className="text-variant-body2 text-brand-navy dark:text-contrast truncate">
          {isCompliance
            ? t('autoAssignToggle.autoAssignedToAll')
            : t('autoAssignToggle.autoAssignToAll')}
        </p>
        <Tooltip.Root delay={200} closeDelay={100}>
          <Focusable>
            <IconInfoCircle className="text-brand-navy dark:text-contrast size-5 cursor-pointer" />
          </Focusable>
          <Tooltip.Content>
            {isCompliance
              ? t('autoAssignToggle.compliancePlanAutoAssignTooltip')
              : t('autoAssignToggle.whenYouEnableThisOptionPathwayWill')}
          </Tooltip.Content>
        </Tooltip.Root>
      </div>
      {!isCompliance && (
        <Switch
          isSelected={isSelected}
          onChange={onChange}
          className="data-[selected=true]:[&>div]:bg-brand-blue! cursor-pointer"
          data-testid="AutoAssignToggle"
        >
          {''}
        </Switch>
      )}
    </div>
  );
};

export default AutoAssignToggle;
